<template>
  <div :class="b({ faded })">
    <ga-product-card-media-item
      v-if="mediaView === MEDIA_VIEW.SINGLE"
      ref="singleMediaRef"
      :class="b('media-item')"
      :is-hovered="isSingleMediaHovered"
      :product-id="productId"
      :source="mediaItems[0]"
      :video-strategy="videoStrategy"
      v-on="mediaListeners"
    />

    <!-- слайдер для touch устройств -->
    <ga-touch-slider
      v-if="mediaView === MEDIA_VIEW.SLIDER"
      :class="b('slider')"
      :items="mediaItems"
      :size-dots="sliderDotsSize"
    >
      <template #item="{ item, visible }">
        <ga-product-card-media-item
          :class="b('media-item')"
          :is-visible="visible"
          :product-id="productId"
          :source="item"
          :video-strategy="videoStrategy"
          v-on="mediaListeners"
        />
      </template>
    </ga-touch-slider>

    <!-- галерея для hover устройств -->
    <ga-hover-gallery
      v-if="mediaView === MEDIA_VIEW.GALLERY"
      ref="hoverGalleryRef"
      :class="b('gallery')"
      :force-visible="isSSR"
      :items="mediaItems"
      :keep-index="isHovering"
    >
      <template #item="{ item, onLoad, hovered, visible }">
        <ga-product-card-media-item
          :class="b('media-item')"
          :is-hovered="hovered"
          :is-visible="visible"
          :product-id="productId"
          :source="item"
          :video-strategy="videoStrategy"
          v-on="mediaListeners"
          @image-load="onLoad()"
        />
      </template>
    </ga-hover-gallery>
  </div>
</template>

<script src="./media.scripts.js" />

<style lang="scss" module src="./media.styles.scss" />
